import React, { useEffect, useState } from 'react'
import { ColorToHex, renderAsText, renderAsHtml } from '../../utility'
import * as styles from './index.module.css'
import Icon from '../icon/icon'
import { Modal, Button } from 'react-bootstrap'
import { linkResolver } from '../../linkResolver'

class SiteWideAlert extends React.Component {
  constructor(props) {
    super(props)

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      window: null,
      show: null
    }
  }

  handleClose() {
    this.setState({ show: "" });
  }

  handleShow(id) {
    this.setState({ show: id });
  }

  componentDidMount() {
    this.setState({ window: window })
  }

  render() {
    let { alerts, id } = this.props

    return alerts?.map((alert, i) => {
      let ctaText = alert.sitewide_alert_learn_more_text || "Learn More";
      if (this.state.window) {
        let dismiss = () => {
          document.getElementById(`sitewide-alert-${i}`).style.transitionDelay =
            '0'
          document.getElementById(
            `sitewide-alert-${i}`
          ).style.transitionDuration = '.2s'
          document.getElementById(`sitewide-alert-${i}`).style.maxHeight = '0'
          document.getElementById(`sitewide-alert-${i}`).style.border =
            '0px solid #FFF'
          this.state.window.sessionStorage.setItem(
            renderAsText(alert.sitewide_alert_title),
            true
          )
        }
        if (
          this.state.window.sessionStorage.getItem(
            renderAsText(alert.sitewide_alert_title)
          )
        )
          return null
        return (
          <React.Fragment key={Math.random(0, 9999999)}>
            <div
              className={`${styles.alertContainer} container-fluid`}
              id={`sitewide-alert-${i}`}
              key={i}
              style={{
                animationDelay: `${0.5 * (i + 1)}s`,
                zIndex: `${1005 - i}`,
              }}
            >
              <div className={styles.wholePageEditButton} data-wio-id={id}></div>
              <div
                className={` ${styles.alertRow} row`}
                style={{
                  backgroundColor: ColorToHex(
                    alert.sitewide_alert_color || 'Zoo Blue'
                  ),
                }}
              >
                <div className={` ${styles.alertCol} col-lg-auto`}>
                  <p className={styles.alertTitle}>
                    {renderAsText(alert.sitewide_alert_title.text)}
                  </p>
                </div>
                <div
                  className={` ${styles.alertCol} ${styles.alertDescriptionCol} col`}
                  {...alert.sitewide_alert_cta === "Modal" && (
                    {
                      onClick: () => this.handleShow(alert.sitewide_alert_modal_id)
                    }
                  )}
                >
                  <p className={styles.alertDescription}>
                    {renderAsText(alert.sitewide_alert_description)}
                  </p>
                  {alert.sitewide_alert_cta === "Modal" && (
                    <button
                      className={styles.alertMoreInfoButton}
                      style={{
                        color: ColorToHex(
                          alert.sitewide_alert_color || 'Zoo Blue'
                        ),
                      }}
                    >
                      {ctaText}
                    </button>
                  )}
                  {alert.sitewide_alert_cta === "Link to Page" && alert.sitewide_alert_learn_more_link && (
                    <a
                      className={styles.alertLearnMoreLink}
                      href={alert.sitewide_alert_learn_more_link.url}
                      style={{
                        color: ColorToHex(
                          alert.sitewide_alert_color || 'Zoo Blue'
                        ),
                      }}
                    >
                      {alert.sitewide_alert_learn_more_text}
                    </a>
                  )}
                </div>
                <div
                  onClick={dismiss}
                  className={` ${styles.alertCol} ${styles.alertCloseCol} justify-content-center col-12 col-lg-auto`}
                >
                  <span className="mr-3">Dismiss</span>
                  <Icon icon="close" width="15" color="white"></Icon>
                </div>
              </div>
            </div>

            {/* Modal */}
            {alert.sitewide_alert_cta === "Modal" && (
              <Modal show={this.state.show == alert.sitewide_alert_modal_id} onHide={this.handleClose}>
                <Modal.Header
                  closeButton
                  className={styles.alertModalHeader}
                >
                  <Modal.Title>
                    <p
                      className={styles.alertModalTitle}
                      style={{
                        color: ColorToHex(
                          alert.sitewide_alert_color || 'Zoo Blue'
                        ),
                      }}
                    >
                      {renderAsText(alert.sitewide_alert_title.text)}
                    </p>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body
                  className={styles.alertModalBody}
                >
                  {alert.sitewide_alert_long_description && (
                    renderAsHtml(alert.sitewide_alert_long_description.richText)
                  )}
                </Modal.Body>
                <Modal.Footer
                  className={styles.alertModalFooter}
                >
                  {alert.sitewide_alert_learn_more_link && (
                    <Button
                      className={styles.alertModalLearnMoreButton}
                      style={{
                        backgroundColor: ColorToHex(
                          alert.sitewide_alert_color || 'Zoo Blue'
                        ),
                      }}
                    >
                      <a
                        className={styles.alertModalLearnMoreLink}
                        href={renderAsText(
                          alert.sitewide_alert_learn_more_link.url
                        )}
                      >
                        {alert.sitewide_alert_modal_button_text}
                      </a>

                    </Button>
                  )}
                  <button
                    onClick={() => {
                      this.handleClose();
                      dismiss();
                    }}
                    className={styles.alertModalDismiss}
                    style={{
                      color: ColorToHex(
                        alert.sitewide_alert_color || 'Zoo Blue'
                      ),
                    }}
                  >
                    Dismiss this alert
                  </button>
                </Modal.Footer>
              </Modal>
            )}
          </React.Fragment>

        )
      }
    })
  }
}

export default SiteWideAlert
